module.exports = __webpack_public_path__ + "img/vegetable-onions-190x100.5892e590.jpg";